import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const NotificationIcon = ({ width = 16, height = 19.5 }) => (
  <NotificationSvg width={width} height={height} viewBox="0 0 16 20">
    <path
      d="M14 14V9C14 5.93 12.36 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.63 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14ZM9 14H7V12H9V14ZM9 10H7V6H9V10ZM8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.89 20 8 20Z"
    />
  </NotificationSvg>
);

NotificationIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const NotificationSvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(NotificationIcon);
